// extracted by mini-css-extract-plugin
export default {"map":"MapPage_map__E5Hl5"};